<template>
  <section>
    <table class="voucher-table">
      <caption>
        웨이브 이용권 표
      </caption>
      <colgroup>
        <col style="width: 230px" />
        <col
          v-for="(_, index) in colCount"
          :key="index"
          :style="{ width: 100 / colCount + '%' }"
        />
      </colgroup>
      <thead>
        <tr>
          <th>
            <span class="a11y-hidden">이용권 상품 목록 (웨이브 이용권)</span>
          </th>
          <th
            v-for="(voucher, thIndex) in voucherList"
            :key="`voucher_head__${thIndex}`"
            scope="col"
          >
            <VoucherTableHead
              :key="`${voucher.quality_name}__${thIndex}`"
              :voucher="voucher"
              :selected-product="selectedProduct"
              @on-click-product="onClickProduct"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <VoucherTableRow
          v-for="(voucher, trIndex) in voucherTableList(
            voucherList,
            bodyDescriptionList,
          )"
          :key="`tr__${trIndex}__${voucher.title}`"
          :voucher="voucher"
        />
      </tbody>
    </table>
  </section>
</template>
<script setup>
  import { defineProps, computed } from 'vue'
  import { useVoucherTable } from '@/common/use/useVoucherTable'
  import VoucherTableRow from '@/components/voucher/VoucherTableRow.vue'
  import VoucherTableHead from '@/components/voucher/VoucherTableHead.vue'

  const {
    selectedProduct,
    refinePurchasePayload,
    getVoucherTableRow,
    voucherTableList,
  } = useVoucherTable()

  const props = defineProps({
    voucherPurchaseFn: {
      type: Function,
      default: () => {},
    },
    voucherList: {
      type: Array,
      default: () => [],
    },
    bodyDescriptionList: {
      type: Array,
      default: () => [],
    },
  })

  const onClickProduct = (voucher, product) => {
    const payload = refinePurchasePayload(voucher, product)

    return props.voucherPurchaseFn(payload)
  }

  const colCount = computed(() => props.voucherList.length)
  const init = () =>
    getVoucherTableRow(props.voucherList, props.bodyDescriptionList)

  init()
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
